import { render, staticRenderFns } from "./TecalChatbot.vue?vue&type=template&id=33a85112&scoped=true"
import script from "./TecalChatbot.vue?vue&type=script&lang=js"
export * from "./TecalChatbot.vue?vue&type=script&lang=js"
import style0 from "./TecalChatbot.vue?vue&type=style&index=0&id=33a85112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a85112",
  null
  
)

export default component.exports